import React from 'react';
import { Link } from 'react-router-dom';
import './LocalFeed.css';

const samplePosts = [
  {
    id: '1',
    title: 'Bible study tonight in New Haven',
    city: 'New Haven',
    category: 'Community',
    time: '7:00 PM',
    attendees: 12
  },
  {
    id: '2',
    title: 'Volunteer outreach — help needed',
    city: 'Hartford',
    category: 'Volunteer',
    time: '2:00 PM',
    attendees: 8
  },
  {
    id: '3',
    title: 'Coffee meetup for young professionals',
    city: 'Stamford',
    category: 'Social',
    time: '9:00 AM',
    attendees: 15
  },
  {
    id: '4',
    title: 'Weekend hiking group at Sleeping Giant',
    city: 'Hamden',
    category: 'Outdoors',
    time: '8:00 AM',
    attendees: 20
  },
];

export default function LocalFeed() {
  return (
    <div className="local-feed-container">
      <div className="feed-header">
        <h1 className="feed-title">Discover Local Events</h1>
        <p className="feed-subtitle">Connect with your community in Connecticut</p>
      </div>

      <div className="posts-grid">
        {samplePosts.map((post, index) => (
          <Link
            to={`/p/${post.id}`}
            key={post.id}
            className="post-card"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="post-category">{post.category}</div>
            <h3 className="post-title">{post.title}</h3>
            <div className="post-details">
              <span className="post-location">📍 {post.city}</span>
              <span className="post-time">🕐 {post.time}</span>
            </div>
            <div className="post-footer">
              <span className="post-attendees">👥 {post.attendees} attending</span>
              <span className="post-action">View Details →</span>
            </div>
          </Link>
        ))}
      </div>

      <div className="feed-notice">
        <p>More events coming soon! This is sample data to preview the interface.</p>
      </div>
    </div>
  );
}
